import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { getPrefixedLogger, prefixes } from '@ringcentral/rwc-utils/src/rwc-logger';
import { isMobile } from '@ringcentral/rwc-utils/src/client-detection';
import useOrientation from '@ringcentral/rwc-utils/src/hooks/use-orientation';
import useMobileKeyboard from '@ringcentral/rwc-utils/src/hooks/use-mobile-keyboard';

const logger = getPrefixedLogger(prefixes.VC_COMPONENTS, 'mobile-states-listener');

/**
 * This listener is server for class component
 * use useMobileKeyboard and useOrientation hooks
 *
 * note: this component only work for MOBILE devices.
 *
 * @param {setState} { onChange }
 * @return {null}
 */
const MobileStatesListener = ({ onChange }) => {
    const isKeyboardVisible = useMobileKeyboard();
    const { orientation } = useOrientation();

    useEffect(() => {
        if (!isMobile) return;

        logger.info(`Virtual keyboard: ${isKeyboardVisible}`);
    }, [isKeyboardVisible]);

    useEffect(() => {
        if (!isMobile) return;

        onChange({ isKeyboardVisible, orientation });
    }, [isKeyboardVisible, orientation, onChange]);

    return null;
};

MobileStatesListener.propTypes = {
    onChange: PropTypes.func,
};

export default MobileStatesListener;
